import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import PublicLayout from 'layout/Public';

// pages
const MarketingHome = Loadable(lazy(() => import('pages/marketing/Landing')));
const CourseCatalog = Loadable(lazy(() => import('pages/marketing/CourseCatalog')));
const CourseCatalogDetail = Loadable(lazy(() => import('pages/marketing/CourseCatalogDetail')));

// ==============================|| PUBLIC ROUTING ||============================== //
// No AuthGuard — this is the marketing site, reachable by anyone. The
// authenticated app's home lives at APP_DEFAULT_PATH instead of '/' (see
// MainRoutes), which is what makes room for this tree at the root.

const PublicRoutes = {
  path: '/',
  element: <PublicLayout />,
  children: [
    {
      path: '/',
      element: <MarketingHome />
    },
    {
      path: 'catalog',
      element: <CourseCatalog />
    },
    {
      path: 'catalog/:slug',
      element: <CourseCatalogDetail />
    }
  ]
};

export default PublicRoutes;
